@if (isLoading == false) {
<div class="frame">
  @for (member of members; track member.email) {
    <div class="member">
      @if (member.photo != "") {
        <img class="image" [src]="member.photo" alt="{{member.name}}" />
      } @else {
        <div class="user-photo-text">
          {{member.name.charAt(0)}}
        </div>
      }
    </div>
  }
</div>
}

